"use client";

import React, { createContext, useContext, useState, type ReactNode } from "react";

interface NavMenuContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const NavMenuContext = createContext<NavMenuContextType | undefined>(undefined);

interface NavMenuProviderProps {
  children: ReactNode;
}

export function NavMenuProvider({ children }: NavMenuProviderProps): React.ReactElement {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <NavMenuContext.Provider
      value={{
        isOpen,
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
        toggle: () => setIsOpen((prev) => !prev),
      }}
    >
      {children}
    </NavMenuContext.Provider>
  );
}

export function useNavMenu(): NavMenuContextType {
  const context = useContext(NavMenuContext);
  if (context === undefined) {
    throw new Error("useNavMenu must be used within a NavMenuProvider");
  }
  return context;
}
